var React = require('react');

function MyAccountIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M7 6a1 1 0 0 0 0 2h10a1 1 0 1 0 0-2H7zM6 12a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1zM7 16a1 1 0 1 0 0 2h7a1 1 0 1 0 0-2H7z","fill":"#fff","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 4a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v16a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V4zm3-1h14a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z","fill":"#fff","key":1})]);
}

MyAccountIcon.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = MyAccountIcon;

MyAccountIcon.default = MyAccountIcon;
